import styled from 'styled-components';

export const PrimaryButtonContainer = styled.button`
  border-radius: ${({ theme }) => theme.borderRadius};
  border: 2px solid ${({ theme }) => theme.colors.yellow2};
  border: none;
  background: ${({ disabled }) =>
    disabled
      ? `var(--grey)`
      : `linear-gradient(
    180deg,
    rgba(254, 210, 66, 1) 4%,
    rgba(253, 220, 94, 1) 31%,
    rgba(242, 175, 23, 1) 100%
  )`};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  box-shadow: ${({ theme }) => theme.shadows.boxShadow};
  span {
    color: ${({ theme }) => theme.colors.grey7} !important;
  }
  &:hover,
  &:active {
    background: ${({ theme }) => theme.colors.yellow5};
    color: ${({ theme }) => theme.colors.grey7};
    border: 2px solid ${({ theme }) => theme.colors.grey7};
    //box-shadow: inset 3px 4px 34px 6px rgba(0, 0, 0, 0.1);
  }
`;
